import { createApp } from "vue/dist/vue.esm-bundler";
import axios from "axios";
import VueAxios from "vue-axios";
import EventBus from "../vue/EventBus.js";

if (document.getElementById("favorites") !== null) {
  const cart = createApp({
    data() {
      return {
        selected_items: [],
        list: {},
        action: 0,
        search_query: "",
        select_all: 0,
        url_prefix: "",
        sortorder: "created_at:desc",
        active_product_notification_product: {},
        translations: TRANSLATIONS,
        list_type: "favorite",
        list_type_copy: "cart",
      };
    },
    methods: {
      changed(item, refresh_all = true) {
        this.clearTimeout(item);

        const vm = this;
        item.debounce = setTimeout(() => {
          var debounce = item.debounce;
          var post_data = {
            quantity: item.quantity,
            note: item.note,
          };
          vm.$http
            .post(
              "/ajax/" + vm.list_type + "/add/" + item.product.id,
              post_data
            )
            .then(() => {
              if (refresh_all && debounce == item.debounce) {
                vm.getData();
              }
            });
        }, 400);
      },
      clearTimeout(item) {
        if (item.debounce) {
          clearTimeout(item.debounce);
        }
      },
      remove(item) {
        const vm = this;
        this.$http
          .delete("/ajax/" + this.list_type + "/remove/" + item.product.id)
          .then(() => vm.getData());
      },
      toCart(item) {
        console.log(item.product.id);
        var post_data = {
          quantity: item.quantity,
        };

        this.$http
          .post("/ajax/cart/add/" + item.product.id, post_data)
          .then(() => EventBus.emit("update-headercart"));
      },
      selectAll() {
        var item_keys = Object.keys(this.list.items);
        for (var key of item_keys) {
          this.list.items[key].selected = this.select_all;
        }
      },
      clearList() {
        const vm = this;
        this.$http.delete("/ajax/" + this.list_type + "/clear").then(() => {
          vm.getData();
        });
      },
      copyToList() {
        this.getSelectedItems();
        this.action = 0;

        var post_data = {
          items: this.selected_items,
        };
        if (this.selected_items.length > 0) {
          this.$http
            .post(
              "/ajax/" + this.list_type + "/" + this.list_type_copy + "/copy",
              post_data
            )
            .then((response) => (window.location.href = response.data.route));
        }
      },
      itemFilter() {
        const vm = this;
        if (this.search_query != "") {
          return $.map(this.list.items, (item) => {
            if (
              item.product.translation.name
                .toLowerCase()
                .search(vm.search_query.toLowerCase()) >= 0 ||
              item.product.itemcode
                .toLowerCase()
                .search(vm.search_query.toLowerCase()) >= 0
            ) {
              return item;
            }
          });
        }
        return this.list.items;
      },
      getData() {
        const vm = this;
        this.getSelectedItems();

        this.$http
          .get(
            "/ajax/" + this.list_type + "/content?sortorder=" + this.sortorder,
            {
              headers: {
                'Accept-Language': LANGUAGE,
              }
            }
          )
          .then(function (response) {
            vm.list = response.data;

            var item_keys = Object.keys(vm.list.items);
            for (var key of item_keys) {
              if (vm.selected_items.includes(vm.list.items[key].product.id)) {
                vm.list.items[key].selected = 1;
              }
            }
            vm.$nextTick(() => {
              vm.scrollToAnchor();
            });
          });
      },
      getSelectedItems() {
        if (typeof this.list.items != "undefined") {
          this.selected_items = [];

          var item_keys = Object.keys(this.list.items);
          for (var key of item_keys) {
            if (this.list.items[key].selected) {
              this.selected_items.push(this.list.items[key].product.id);
            }
          }
        }
      },
      parseEntities(string) {
        var txt = document.createElement("textarea");
        txt.innerHTML = string;
        return txt.value;
      },
      scrollToAnchor() {
        if (window.location.hash.substr(1) !== "") {
          const anchor = window.location.hash.substr(1);
          if ($("#" + anchor).length) {
            $("html, body").animate(
              {
                scrollTop:
                  $("#" + anchor).offset().top -
                  ($("header").height() +
                    $(".sticky-header").first().height() +
                    20),
              },
              0
            );
          }
        }
      },
    },
    created() {
      this.url_prefix = URL_PREFIX;
      this.getData();
    },
    mounted() {
    }
  })
    .use(VueAxios, axios)
    .mount("#favorites");
}
